<template>
  <div class="form-field mb-3" :class="formWrapperClass">
    <div class="">
      <label v-if="label"
        >{{ label }}
        <span class="text-highlighted">{{ required ? " *" : "" }}</span></label
      >
    </div>
    <div v-if="type === 'select'">
      <select
        :id="id"
        v-model="tmpValue"
        @input="updateValue($event.target.value)"
        class="form-control"
        :required="required"
        :disabled="disabled"
      >
        <option value="" disabled selected>{{ placeholder }}</option>
        <option
          :value="option.value"
          v-for="(option, i) in tmpOptions"
          :key="i"
          >{{ option.label }}</option
        >
      </select>
    </div>
    <div v-else-if="type === 'radio'">
      <b-form-group>
        <b-form-radio-group
          :id="id"
          v-model="tmpValue"
          @change="updateValue($event)"
          :options="options"
          :required="required"
          :disabled="disabled"
        ></b-form-radio-group>
      </b-form-group>
    </div>
    <div v-else-if="type === 'radio-button'">
      <b-form-group>
        <b-form-radio-group
          :id="id"
          v-model="tmpValue"
          @change="updateValue($event)"
          :required="required"
          :disabled="disabled"
          buttons
          button-variant="outline-highlighted"
          ><b-form-radio
            v-for="(option, i) in options"
            :key="i"
            :value="option.value"
            ><font-awesome-icon :icon="option.icon" class="mr-2" />{{
              option.text
            }}</b-form-radio
          ></b-form-radio-group
        >
      </b-form-group>
    </div>
    <div v-else-if="type === 'date'">
      <b-form-group>
        <date-picker
          v-model="tmpValue"
          :input-props="{
            id: id,
            placeholder: placeholder,
            class: 'form-control',
            required: required,
            disabled: disabled
          }"
          @input="updateValue($event)"
        />
      </b-form-group>
    </div>
    <div v-else-if="type === 'file'">
      <b-form-group>
        <b-form-file
          :id="id"
          v-model="tmpValue.file"
          :placeholder="placeholder"
          drop-placeholder="Presuňte súbor sem"
          @change="readFile(tmpValue, $event)"
          :accept="accept"
          :required="required"
          :disabled="disabled"
        ></b-form-file>
      </b-form-group>
    </div>
    <div v-else>
      <input
        :id="id"
        :value="value"
        @input="updateValue($event.target.value)"
        :placeholder="placeholder"
        :type="type"
        v-mask="mask"
        class="form-control"
        :required="required"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
export default {
  name: "FormField",
  components: {
    DatePicker
  },
  mounted() {
    this.tmpValue = this.value;
  },
  computed: {
    tmpOptions() {
      if (typeof this.options === "function") {
        return this.options();
      } else {
        return this.options;
      }
    }
  },
  data() {
    return {
      tmpValue: ""
    };
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    id: {
      type: String
    },
    value: {
      type: [String, Number, Object, Date],
      default: "",
      required: true
    },
    formWrapperClass: {
      type: String,
      default: "col-md-7"
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    options: {
      type: [Array, Function],
      default: function() {
        return [];
      }
    },
    mask: {
      type: String,
      default: ""
    },
    accept: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateValue: function(value) {
      if (value instanceof Date) {
        this.$emit("input", value.toISOString());
      } else {
        this.$emit("input", value);
      }
    },
    readFile: function(item, ev) {
      const file = ev.target.files[0];
      item.extension = file.name
        .split(".")
        .pop()
        .toLowerCase();
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onloadend = e => {
        const arrayBuffer = e.target.result;
        item.hex = Array.prototype.map
          .call(new Uint8Array(arrayBuffer), x =>
            ("00" + x.toString(16)).slice(-2)
          )
          .join("");
      };
    }
  }
};
</script>

<style lang="scss">
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "+" !important;
  font-size: 24px;
  line-height: 22px;
  font-family: monospace;
  color: gray;
  height: 30px;
  background: white;
  border: none;
}

.custom-file-label {
  padding-top: 10px !important;
  border-radius: unset !important;
}
</style>
